// extracted by mini-css-extract-plugin
module.exports = {"info":"_e327c15","infoHeader":"_502e706","infoContent":"_995811b","infoIcon":"_f6250b7","collapseTitle":"_3c3ed22"};